const note = {
    version: '1.2.0',
    date: '2026-09-16',
    tags: ['Nyt'],
    body: `
- **Nav Queue.** Ny fane med de timelogs, der endnu ikke er nået frem til CapLegal, og dem Nav har afvist.
- **Sortering og filter.** Tabellen kan sorteres på alle kolonner og filtreres på employee.
- **Ny work type på en afvist timelog.** Den kan rettes direkte i dashboardet og sendes af sted igen.
`,
};

export default note;
